import qs from 'qs';

import { Filter, ItemList } from '../types/main';
import { MimeListItem, Item } from '../types/items';

export const getSegmentRoutePath = (path: string, position: number): string => {
  // eslint-disable-next-line
  path = path[0] === '/' ? path.slice(1) : path;
  // eslint-disable-next-line
  position -= 1;
  // eslint-disable-next-line
  let array = path.split('/');

  if (array.length >= position) {
    return array[position];
  }
  return '';
};

export const clipRoutePath = (path: string, countSegment: number): string => {
  // eslint-disable-next-line
  path = path[0] === '/' ? path.slice(1) : path;
  // eslint-disable-next-line
  let arrayPath = path.split('/');

  if (arrayPath.length > countSegment) {
    arrayPath.splice(countSegment);
  }

  return `/${arrayPath.join('/')}`;
};

export const getQueryFilter = (key: string, filters: Filter[]): Filter | undefined => filters.find((item) => item.key === key);

export const browserDetect = () => ({
  isChrome: navigator.userAgent.toLowerCase().indexOf('chrome') > -1,
  isSafari: navigator.userAgent.toLowerCase().indexOf('safari') > -1,
  isFirefox: navigator.userAgent.toLowerCase().indexOf('firefox') > -1,
  isIE: navigator.userAgent.toLowerCase().indexOf('msie') > -1,
  isOpera: navigator.userAgent.toLowerCase().indexOf('opera') > -1,
});

export const detectIOS = (): boolean =>
  // @ts-ignore
  [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod',
  ].includes(navigator.platform) || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);

export const detectMob = ():boolean =>
  [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod',
    'Android',
    'BlackBerry',
  ].includes(navigator.platform) || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);


export const detectMac = (): boolean => {
  // @ts-ignore
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return (userAgent && /mac/.test(userAgent.toLowerCase()) && !window.MSStream);
};

export const getExtensionFromMimeType = ({ mime, mimeList }:{ mime: string; mimeList: MimeListItem[] }): string => {
  const mimeItem = mimeList.find((item) => item.mime_type_id === mime);
  if (mimeItem === undefined) {
    return '';
  }
  return mimeItem.extension;
};

// eslint-disable-next-line
export const updateQuery = (params: {[key:string]: any}) => {
  const { protocol, host, pathname } = window.location;
  const path = `${protocol}//${host}${pathname}?${qs.stringify(params)}`;
  window.history.replaceState({ path }, '', path);
};

export const removeQueryParams = () => {
  const { protocol, host, pathname } = window.location;
  const path = `${protocol}//${host}${pathname}`;
  window.history.replaceState({ path }, '', path);
};

export const getQueryData = (
  query = window.location.search,
): Pick<ItemList<Item>, 'filters' | 'pagination' | 'sorting'> => {
  const {
    page: rawPage,
    page_size: rawPageSize,
    sort_key: sortKey,
    sort_dir: dir,
    filter,
  } = qs.parse(query, { ignoreQueryPrefix: true });

  const page = parseInt(rawPage, 10) || 0;
  const pageSize = parseInt(rawPageSize, 10) || 10;

  return {
    filters: {
      available: [],
      active: filter
        ? Object.entries<string>(filter).map(([key, value]) => ({ key, value }))
        : [],
    },
    sorting: {
      available: [],
      dir,
      key: sortKey,
    },
    pagination: {
      totalItems: 0,
      page,
      pageSize,
    },
  };
};

// eslint-disable-next-line
export const getAllQueryData = (): {[key:string]: any} => {
  const query = window.location.search;
  return qs.parse(query, { ignoreQueryPrefix: true });
};

export const formatBytes = (b: number) => {
  const units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  let l = 0;
  let n = b;

  while (n >= 1024) {
    n /= 1024;
    l += 1;
  }

  return `${n.toFixed(n >= 10 || l < 1 ? 0 : 1)}${units[l]}`;
};

export const formatDuration = (seconds: number) => {
  const date = new Date(0);
  const isCountdown = seconds < 0;
  const secondsAbs = Math.abs(seconds);
  date.setSeconds(secondsAbs);
  const dateString = date.toISOString().slice(11, 19);
  if (secondsAbs < 3600) return isCountdown ? `-${dateString.slice(3)}` : dateString.slice(3);
  return isCountdown ? `-${dateString}` : dateString;
};

export const otherVideoTypes = (name: string) => {
  const videoTypes = [
    '.ts',
  ];

  return videoTypes.some((type) => name.endsWith(type));
};

export const checkAccepts = (file: File, accept: string) => {
  if (!accept || accept === '*') return true;

  if (otherVideoTypes(file.name)) {
    return true;
  }

  const mimeType = file.type || '';
  const baseMimeType = mimeType.replace(/\/.*$/, '');

  return accept
    .split(',')
    .map((t) => t.trim())
    .some((type) => {
      if (type.charAt(0) === '.') {
        return file.name === undefined || file.name.toLowerCase().endsWith(type.toLowerCase());
      }
      if (type.endsWith('/*')) {
        // this is something like an image/* mime type
        return baseMimeType === type.replace(/\/.*$/, '');
      }
      return mimeType.toLocaleLowerCase() === type.toLocaleLowerCase();
    });
};

export const stringifyQuery = (query: {}) => qs.stringify(query);

export const parseQuery = (query: string) => qs.parse(query, { ignoreQueryPrefix: true });

export const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const getUrlWithoutQuery = (url: string) => {
  const urlWithoutQuery = url.split('?');
  if (urlWithoutQuery.length > 0) {
    return urlWithoutQuery[0];
  }

  return url;
};

export const padNumber = (number: number, size: number): string => {
  let result = number.toString();

  while (result.length < size) result = `0${result}`;

  return result;
};
